import { GeneralPropsType } from "@/common/types";
import styles from "./index.module.css";
import clsx from "clsx";
import DynamicSizeIcon from "../DynamicSizeIcon";
import DynamicFontSize from "../DynamicFontSize";
import { useGlobalData } from "@/contexts/GlobalData";
export interface ConnectBankOptionPropsType extends GeneralPropsType {
  icon?: string;
  name?: string;
  des?: string;
  onClick?: (data?: any) => any;
  hideNavigationArrow?: boolean;
}
function ConnectBankOption({
  children,
  icon,
  des,
  name,
  className,
  hideNavigationArrow,
  onClick
}: ConnectBankOptionPropsType) {
  const {
    getIcon
  } = useGlobalData();
  return <div onClick={onClick} className={clsx("flex items-center gap-2 cursor-pointer", styles.container, className)} data-sentry-component="ConnectBankOption" data-sentry-source-file="index.tsx">
            <DynamicSizeIcon width={36} icon={icon} data-sentry-element="DynamicSizeIcon" data-sentry-source-file="index.tsx"></DynamicSizeIcon>
            <div className="flex flex-col flex-1">
                <DynamicFontSize fontSize={14} className="text-white" data-sentry-element="DynamicFontSize" data-sentry-source-file="index.tsx">
                    {name}
                </DynamicFontSize>
                {des && <DynamicFontSize fontSize={13} className="text-description">
                        {des}
                    </DynamicFontSize>}
            </div>
            {children}
            {!hideNavigationArrow && <DynamicSizeIcon className="ml-auto" width={7} height={11} icon={getIcon("right_arrow_setting")}></DynamicSizeIcon>}
        </div>;
}
export default ConnectBankOption;